(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TransportationDialogController', TransportationDialogController);

    TransportationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Transportation'];

    function TransportationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Transportation) {
        var vm = this;
        vm.transportation = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:transportationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.transportation.id !== null) {
                Transportation.update(vm.transportation, onSaveSuccess, onSaveError);
            } else {
                Transportation.save(vm.transportation, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
